import React from "react";
import Svg, { G, Path } from "react-native-svg";

type Avatar13Colors = {
  background?: string;
  skin?: string;
  hair?: string;
};

export const Avatar13 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar13Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar13">
        <G id="Group">
          <Path
            id="background"
            d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
            fill={c.background}
          />
          <Path
            id="Vector"
            d="M161.914 253.059c-36.064-5.338-83.892 2.883-99.207 4.805-6.006.755-11.383 1.891-16.197 3.313 27.302 26.301 64.422 42.482 105.324 42.482 32.862 0 63.286-10.446 88.133-28.192-21.479-9.063-52.602-18.643-78.061-22.408h.008Z"
            fill="#000"
          />
          <Path
            id="skin"
            d="M242.406 134.985c7.428-98.993-72.389-104.593-72.389-104.593s-67.727 5.918-80.739 25.73c-13.011 19.819-12.154 74.558-3.98 79.189.048 2.637 8.008 9.961 9.2 13.035 8.403 21.623 15.982 17.945 23.52 21.472-1.295 24.037-3.455 56.097-6.482 63.834-7.888 20.153-19.843 22.298-19.843 22.298s38.614 36.993 73.065 47.153a151.211 151.211 0 0 0 29.383-5.426c6.228-9.453 10.494-25.705-10.255-36.532-5.592-6.164 2.026-30.4 2.836-43.666 9.89 1.763 25.189 9.778 35.365-1.35 2.303-11.511 15.347-30.893 23.401-54.605.541-8.729-4.257-10.604-3.066-26.555l-.016.016Z"
            fill={c.skin}
          />
          <Path
            id="hair"
            d="M136.955 26.206C56.169 36.89 66.178 109.002 72.191 145.384c-53.078 10.35-39.392 65.097-28.04 75.781 11.351 10.684 36.39 10.017 50.743-1.001 14.354-11.017 2.67-41.592 2.67-41.592s9.118 7.53 14.274 12.495c5.155 4.957 4.559 12.098 4.559 12.098l3.48-33.204s-12.003-2.884-20.336-16.761c-8.325-13.877-6.148-33.506 10.112-34.896 16.261-1.39 25.579 30.138 25.579 30.138s1.787-11.304 1.986-19.43c.087-3.44 1.318-7.022 3.646-10.732-2.749.993-5.934 1.772-9.08 1.708-4.901-.087-13.035-2.613-11.462-4.051 15.442 2.272 17.888-.691 29.979-8.428.421-.382.865-.763 1.302-1.144-10.469-2.097-31.877-4.631-46.485 5.481 0 0 9.373-12.297 22.44-13.218 9.334-.66 23.458 1.112 30.758 2.184 3.249-3.161 5.695-7.419 8.205-12.018-15.259-4.361-65.963-14.918-80.007 32.433-2.018 6.808 3.225-41.966 41.354-41.815 22.321.088 36.215.922 43.118 1.486 1.279-2.09 2.677-4.163 4.257-6.14-11.637-3.861-46.215-13.544-72.294-2.447 0 0 19.168-12.662 35.873-10.55 11.431 1.446 30.853 5.116 41.974 7.285a35.304 35.304 0 0 1 5.966-4.043c-52.841-30.615-92.106 1.064-92.106 1.064 41.028-41.72 87.339-11.685 98.111-3.662a42.097 42.097 0 0 1 3.336-1c3.845-.978 7.38-1.303 10.629-1.169-9.485-16.18-50.99-25.212-50.99-25.212 34.697-1.28 51.903 17.523 54.723 25.586 2.256.365 4.345.961 6.276 1.708-2.233-5.751-8.881-12.782-7.205-12.043 6.1 2.677 9.349 9.334 10.89 13.75 9.731 5.299 14.331 14.235 14.331 14.235s-15.387-62.936-97.81-52.038l.008-.016Z"
            fill={c.hair}
          />
          <Path
            id="Vector_2"
            opacity={0.75}
            d="M186.166 216.963c-26.5-5.672-40.846-23.044-47.153-28.645-.008.517 11.812 46.121 44.19 52.396.897-7.888 3.447-23.648 2.963-23.751Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_3"
            opacity={0.75}
            d="M223.564 174.457c-3.551.174-6.021 2.287-6.021 2.287s-3.209-2.28-6.982-2.097c-3.774.183-7.126 2.566-10.653 3.289-3.566.731-9.802.349-9.802.349.874.898 13.059 17.365 26.635 16.706 11.558-.564 15.243-14.172 15.514-14.863 0 0-5.14-5.838-8.691-5.664v-.007Zm-5.298 13.241c-11.653.564-18.969-4.067-23.259-6.799-.095-.064-.008-.199.095-.151 4.33 1.843 11.844 3.074 23.466 2.51 5.989-.294 9.945-.54 13.218-1.859-3.257 1.629-7.547 6.006-13.52 6.299Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_4"
            opacity={0.75}
            d="M232.523 161.755c-1.835-.715-4.297 2.478-10.39 2.478-8.889 0-13.448-2.995-14.131-.318-.692 2.677 2.621 4.457 13.988 4.004 9.358-.373 12.376-5.449 10.541-6.164h-.008Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_5"
            d="M187.166 104.244c-10.279-1.112-12.55 1.469-21.892 9.095 0 0 10.192-2.478 20.915-2.399 12.599.096 17.516 8.69 19.939 4.147.77-1.446 4.011-8.349-18.962-10.843Z"
            fill="#000"
          />
          <Path
            id="Vector_6"
            d="M203.936 133.817c-3.273-5.6-8.715-10.763-15.53-12.018-3.074-.358-6.18-.016-9.103 1.12-2.391.913-4.234 2.43-6.006 3.94-2.399 1.66-5.592 1.024-8.484.691 2.725 1.906 6.768 3.439 10.089 1.803a29.956 29.956 0 0 1 2.311-1.35c-.023.238-.047.476-.047.722 0 4.457 3.733 8.063 8.34 8.063 4.608 0 8.341-3.614 8.341-8.063 0-.365-.032-.722-.079-1.072 3.273 1.501 6.561 3.726 10.168 6.156v.008Z"
            fill="#000"
          />
          <Path
            id="Vector_7"
            d="M242.374 109.327c-15.888-.476-21.615 8.333-19.907 11.606 1.056 2.025 4.297 2.113 6.688-.183 6.554-5.624 6.689-3.741 13.56-3.837-.119-2.391-.103-5.592-.341-7.586Z"
            fill="#000"
          />
          <Path
            id="Vector_8"
            d="M251.057 129.393c-1.772-1.517-3.615-3.027-6.006-3.94-2.923-1.136-6.029-1.478-9.103-1.12-6.823 1.255-12.257 6.418-15.53 12.018 1.851-1.255 3.623-2.446 5.346-3.519.318 3.917 3.702 6.999 7.833 6.999 4.345 0 7.864-3.408 7.864-7.61 0-1.43-.429-2.749-1.136-3.893 2.812.31 5.799 1.406 9.119 3.551 3.321 1.645 7.356.111 10.089-1.803-2.892.334-6.077.969-8.476-.691v.008Z"
            fill="#000"
          />
        </G>
      </G>
    </Svg>
  );
};
